// @flow

import { css } from 'styled-components';

const rowCut = (bgColor: string, reversed: boolean = false) => css`
  box-sizing: border-box;
  overflow: hidden;

  &:after {
    content: "";
    display: block;
    height: 0;
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    box-sizing: content-box;
    border-bottom: 6vw solid ${bgColor};
    ${reversed ? 'border-right: 100vw solid transparent' : 'border-left: 100vw solid transparent'};
  }
`;

export default rowCut;
